export  default {
    hasUpperCase(text) {
        return !(text === text.toLowerCase());
    },
    hasLowerCase(text) {
        return !(text === text.toUpperCase());
    },
    hasInteger(text) {
        return !!parseInt(text.replace(/\D/g, ''));
    },
    hasSymbol(text) {
        return !/^[a-zA-Z0-9]+$/.test(text)
    }
}